import { Button, Card, CardProps, Flex, rem, Text, Title, Transition } from "@mantine/core"
import { useHover, useMediaQuery } from "@mantine/hooks"
import { UPLOAD_BASE_URL } from "api/routes"
import Image from "common/image"
import LinkWithQuery from "common/link-with-query"
import { FC } from "react"
import { IModels } from "rules/interface/models/models.interface"
import { addThumbnailPostfixToImageName } from "utils/general"
import styles from "./index.module.scss"



export interface ModelCardProps extends CardProps {
    data?: IModels
    whitinTitle?: boolean
    whitinMetrage?: boolean
    whitinButton?: boolean
}


const ModelCard: FC<ModelCardProps> = ({ data, whitinTitle, whitinButton, whitinMetrage, ...props }) => {
    const mobileMatches = useMediaQuery('(max-width: 768px)')
    const { hovered, ref } = useHover()



    return (
        <LinkWithQuery href={"/models/" + data.url} queryParams={["utm_source", "utm_campaign"]}>
            <Card
                radius={rem(16)}
                p={0}
                className={styles.card}
                pos="relative"
                ref={ref}
                style={{ transition: "all 400ms" }}
                {...props}
            >
                <Card className={styles.header__card} p={0} radius="0 0 16px 16px" h={{ base: rem(200), sm: rem(300) }}>
                    <Image
                        className={styles.img__header + " object-fit-cover"}
                        unoptimized
                        src={
                            data?.mainPictureAdress?.url
                                ? UPLOAD_BASE_URL +
                                addThumbnailPostfixToImageName(data.mainPictureAdress.url)
                                : "/images/media/brokenImage.png"
                        }
                        alt={data?.mainPictureAdress?.alt ?? "تصویر مدل"}
                        width={400}
                        height={mobileMatches ? 200 : 300}
                        objectFit="cover"
                    />
                </Card>

                <Flex direction="column" py={(whitinTitle || whitinMetrage) ? 0 : rem(16)} px={rem(14)}>
                    {
                        (!whitinTitle && !whitinMetrage) &&
                        <Flex align="center" justify="space-between" style={{ borderBottom: "1px solid #DFDFDF" }} py="xs">
                            <Title
                                order={4}
                                c="gray.10"
                                fw={600}
                                fz={{ base: rem(16), sm: rem(18) }}
                                lineClamp={1}
                            >
                                {data.title}
                            </Title>
                        </Flex>
                    }

                    <Flex align="center" justify="space-between" py="xs" gap={8}>
                        {
                            whitinMetrage ?
                                <Title
                                    order={4}
                                    c="gray.10"
                                    fw={600}
                                    fz={{ base: rem(16), sm: rem(18) }}
                                    lineClamp={1}
                                >
                                    {data.title}
                                </Title>
                                :
                                <Title
                                    order={5}
                                    c="gray.10"
                                    fw={600}
                                    fz={{ base: rem(16), sm: rem(18) }}
                                >
                                    {data.modelArea ?? 0} <Text c="black" display="inline" fz={rem(14)} fw={600}>متر</Text>
                                </Title>
                        }

                        <Title
                            order={5}
                            c="gray.10"
                            fw={600}
                            fz={{ base: rem(16), sm: rem(18) }}
                            style={{ whiteSpace: 'pre' }}
                        >
                            {Math.ceil((data.newCost ?? 0) / 1000000)} <Text c="gray.10" display="inline" fz={rem(14)} fw={600}>میلیون</Text>
                        </Title>
                    </Flex>

                    {
                        !whitinButton &&
                        <Transition
                            mounted={mobileMatches ? true : hovered}
                            transition={"fade-up"}
                            duration={400}
                            keepMounted
                        >
                            {(transitionStyle) => (
                                <Button
                                    style={transitionStyle}
                                    leftSection={
                                        <svg width={mobileMatches ? "15" : "24"} height={mobileMatches ? "15" : "25"} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2 2.5H3.30616C3.55218 2.5 3.67519 2.5 3.77418 2.54524C3.86142 2.58511 3.93535 2.64922 3.98715 2.72995C4.04593 2.82154 4.06333 2.94332 4.09812 3.18686L4.57143 6.5M4.57143 6.5L5.62332 14.2314C5.75681 15.2125 5.82355 15.7031 6.0581 16.0723C6.26478 16.3977 6.56108 16.6564 6.91135 16.8174C7.30886 17 7.80394 17 8.79411 17H17.352C18.2945 17 18.7658 17 19.151 16.8304C19.4905 16.6809 19.7818 16.4398 19.9923 16.1342C20.2309 15.7876 20.3191 15.3247 20.4955 14.3988L21.8191 7.44969C21.8812 7.12381 21.9122 6.96087 21.8672 6.8335C21.8278 6.72177 21.7499 6.62768 21.6475 6.56802C21.5308 6.5 21.365 6.5 21.0332 6.5H4.57143ZM10 21.5C10 22.0523 9.55228 22.5 9 22.5C8.44772 22.5 8 22.0523 8 21.5C8 20.9477 8.44772 20.5 9 20.5C9.55228 20.5 10 20.9477 10 21.5ZM18 21.5C18 22.0523 17.5523 22.5 17 22.5C16.4477 22.5 16 22.0523 16 21.5C16 20.9477 16.4477 20.5 17 20.5C17.5523 20.5 18 20.9477 18 21.5Z" stroke={mobileMatches ? "#F57F22" : "white"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    }
                                    variant={mobileMatches ? "outline" : "filled"}
                                    radius={mobileMatches ? 12 : 24}
                                    fz={{ base: rem(14), sm: rem(18) }}
                                    px={{ sm: "24px" }}
                                    h={{ sm: "60px" }}
                                    pos={{ sm: "absolute" }}
                                    top={{ sm: 135 }}
                                    left={{ sm: 0 }}
                                    right={{ sm: 0 }}
                                    w={{ sm: "fit-content" }}
                                    mx={{ sm: "auto" }}
                                    my={{ base: rem(12), sm: 0 }}
                                >
                                    سفـارش این مـدل
                                </Button>
                            )}
                        </Transition>
                    }
                </Flex>
            </Card>
        </LinkWithQuery>
    )
}

export default ModelCard